import { render } from "./LayoutMaster.vue?vue&type=template&id=1883aca5"
import script from "./LayoutMaster.vue?vue&type=script&lang=js"
export * from "./LayoutMaster.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__